import pkg from '../package.json'

export default {
  version: pkg.version,
  product: 'iKG',
}
